module.exports = __webpack_public_path__ + "static/media/blueenergy.b0281bd5.png";